import { EntityDrawerProps, FormDrawer, FormDrawerContent, TextField } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ContactUpdateInquiryBaseDataResource } from "../../shared/types/contactUpdateInquiry";

export const ContactPersonalInformationDrawer: FC<EntityDrawerProps<ContactUpdateInquiryBaseDataResource>> = (
	props,
) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: ContactUpdateInquiryBaseDataResource) => {
			const errors: { [K in keyof ContactUpdateInquiryBaseDataResource]?: any } = {};

			if (!values.firstName) {
				errors.firstName = t("Required field");
			}

			if (!values.lastName) {
				errors.lastName = t("Required field");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="firstName" label={t("First name")} />
					<TextField name="lastName" label={t("Last name")} />
				</FormDrawerContent>
			)}
		/>
	);
};
